import pathToRegexp from 'path-to-regexp';

export enum AppRoute {
  Root = 'Root',
  AboutUs = 'AboutUs',
  CloudAnalytics = 'CloudAnalytics',
  Encoding = 'Encoding',
  LiveEncoding = 'LiveEncoding',
  Login = 'Login',
  OnPremiseAnalytics = 'OnPremiseAnalytics',
  OnPremiseEncoding = 'OnPremiseEncoding',
  Player = 'Player',
  Playback = 'Playback',
  DemoDetail = 'DemoDetail'
}

export const AppRouteToPath = {
  [AppRoute.Root]: '/',
  [AppRoute.AboutUs]: '/about-us',
  [AppRoute.CloudAnalytics]: '/cloud-analytics',
  [AppRoute.Encoding]: '/encoding',
  [AppRoute.LiveEncoding]: '/live-encoding',
  [AppRoute.Login]: '/login',
  [AppRoute.OnPremiseAnalytics]: '/on-premise-analytics',
  [AppRoute.OnPremiseEncoding]: '/on-premise-encoding',
  [AppRoute.Player]: '/player',
  [AppRoute.Playback]: '/playback',
  [AppRoute.DemoDetail]: '/demos/:demoId'
};

export const AppRoutePathFunction = {
  [AppRoute.Root]: pathToRegexp.compile(AppRouteToPath[AppRoute.Root]),
  [AppRoute.AboutUs]: pathToRegexp.compile(AppRouteToPath[AppRoute.AboutUs]),
  [AppRoute.CloudAnalytics]: pathToRegexp.compile(AppRouteToPath[AppRoute.CloudAnalytics]),
  [AppRoute.Encoding]: pathToRegexp.compile(AppRouteToPath[AppRoute.Encoding]),
  [AppRoute.LiveEncoding]: pathToRegexp.compile(AppRouteToPath[AppRoute.LiveEncoding]),
  [AppRoute.Login]: pathToRegexp.compile(AppRouteToPath[AppRoute.Login]),
  [AppRoute.OnPremiseAnalytics]: pathToRegexp.compile(AppRouteToPath[AppRoute.OnPremiseAnalytics]),
  [AppRoute.OnPremiseEncoding]: pathToRegexp.compile(AppRouteToPath[AppRoute.OnPremiseEncoding]),
  [AppRoute.Player]: pathToRegexp.compile(AppRouteToPath[AppRoute.Player]),
  [AppRoute.Playback]: pathToRegexp.compile(AppRouteToPath[AppRoute.Playback]),
  [AppRoute.DemoDetail]: pathToRegexp.compile(AppRouteToPath[AppRoute.DemoDetail])
};
